var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-base font-medium mb-3"},[_vm._v(" "+_vm._s(_vm.$t('Services.AddedOrders'))+" ")]),_c('div',{staticClass:"flex flex-col gap-3"},_vm._l((_vm.serviceOrders),function(order){return _c('Card',{key:order.id,attrs:{"title":order.service_provider.name,"subtitle":order.bookable.name,"selected":"","action":order.is_editable ? {
          label: _vm.$t('Services.Details.Delete'),
          danger: true,
          icon: _vm.Trash2,
          onClick: () => _vm.deleteOrder(order),
        } : {
          label: _vm.$t('Services.Details.Revoke'),
          danger: true,
          icon: _vm.RotateCcw,
          onClick: () => _vm.revokeOrder(order),
        }},on:{"open":function($event){return _vm.$emit('edit', order)}},scopedSlots:_vm._u([{key:"details",fn:function(){return [_c('ServiceOrderStatus',{attrs:{"status":order.status}}),_vm._v(" "+_vm._s(_vm.totalPrice(order))+" €, "+_vm._s(_vm.$tc('Services.Items', _vm.totalItems(order)))+" ")]},proxy:true}],null,true)})}),1),_c('div',{staticClass:"divider my-4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }